import React from "react";
import { Box, Container, Grid, Typography, Divider, Link } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as Emotion10ThemeProvider } from "@emotion/react";
import { Link as RouterLink } from "react-router-dom";
import ROUTES from "../../routes/routesModel";
import RightFooter from "./components/RightFooter";
import MiddleFooter from "./components/MiddleFooter";
import LeftFooter from "./components/LeftFooter";

const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#047ABC",
      light: "#f8f9fa",
    },
    text: {
      primary: "#2d3436",
      secondary: "#636e72",
    },
  },
});

const Footer: React.FC = () => {
  return (
    <footer>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Emotion10ThemeProvider theme={theme}>
          {/* Original Footer */}
          <Box
            sx={{
              bgcolor: "#047ABC",
              color: "#ffffff",
              pt: 6,
              pb: 4,
              boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Container maxWidth="lg">
              <Grid
                container
                spacing={4}
                sx={{
                  direction: "rtl",
                  mb: 4,
                }}
              >
                <RightFooter />
                <MiddleFooter />
                <LeftFooter />
              </Grid>

              {/* <Divider
                sx={{ my: 3, borderColor: "rgba(255, 255, 255, 0.2)" }}
              /> */}
            </Container>
          </Box>

          {/* Half White Divider */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#047ABC",
            }}
          >
            <Box
              sx={{
                width: "65%",
                height: "4px",
                background: "#ffffff",
                opacity: 0.5,
                marginRight: 0,
                marginLeft: "auto",
              }}
            />
          </Box>

          {/* מידע חשוב Section */}
          <Box
            sx={{
              bgcolor: "#047ABC",
              color: "#ffffff",
              pt: 6,
              pb: 4,
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "#ffffff",
                  mb: 4,
                  textAlign: "center",
                }}
              >
                מידע ותמיכה טכנית
              </Typography>

              <Grid container spacing={4} sx={{ direction: "rtl" }}>
                {/* Right Column */}
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#ffffff",
                      mb: 3,
                    }}
                  >
                    ניווט מהיר
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Link
                      component={RouterLink}
                      to={ROUTES.ROOT}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      דף ראשי
                    </Link>
                    <Link
                      component={RouterLink}
                      to={ROUTES.CONTACT}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      צרו איתנו קשר
                    </Link>
                    <Link
                      component={RouterLink}
                      to={ROUTES.ACCESSIBILITY}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      הצהרת נגישות
                    </Link>
                  </Box>
                </Grid>

                {/* Middle Column */}
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#ffffff",
                      mb: 3,
                    }}
                  >
                    חשבון משתמש
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Link
                      component={RouterLink}
                      to={ROUTES.LOGIN}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      התחברות
                    </Link>
                    <Link
                      component={RouterLink}
                      to={ROUTES.PRIVACY_POLICY}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      מדיניות פרטיות
                    </Link>
                  </Box>
                </Grid>

                {/* Left Column */}
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#ffffff",
                      mb: 3,
                    }}
                  >
                    מידע משפטי
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Link
                      component={RouterLink}
                      to={ROUTES.TERMS}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      תקנון אתר ותנאי השימוש
                    </Link>
                    <Link
                      component={RouterLink}
                      to={ROUTES.FAQ}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      שאלות נפוצות
                    </Link>
                    <Link
                      component={RouterLink}
                      to={ROUTES.CANCEL_TRANSACTION}
                      sx={{
                        color: "#e3f2fd",
                        textDecoration: "none",
                        "&:hover": { color: "#ffffff" },
                        fontWeight: 500,
                      }}
                    >
                      ביטול עסקה
                    </Link>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* Copyright Section */}
          <Box
            sx={{
              bgcolor: "#047ABC",
              color: "#ffffff",
              py: 3,
              textAlign: "center",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="body2"
                sx={{
                  color: "#e3f2fd",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                }}
              >
                © {new Date().getFullYear()} לב הארץ. כל הזכויות שמורות.
              </Typography>
            </Container>
          </Box>
        </Emotion10ThemeProvider>
      </ThemeProvider>
    </footer>
  );
};

export default Footer;
